/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_COMPARACION,
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import {VISIBILIDADMOVIMIENTO} from "../../Constantes";
import Dialogo_Movimientos from "../Dialogos/Dialogo_Movimientos";


const Seccion_Movimientos = () => {
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025({coleccion: 'movimientos'});
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Movimientos,
        titulo: 'Detalles del Movimiento',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista movimientos'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Movimientos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: '# y tipo',
        direccion: 'left',
        propiedades: ['consecutivo', 'tipo'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: "correo",
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        titulo: 'moneda',
        siTitulo: 'PUNTOS',
        tipo: CASILLA_COMPARACION

    },
    {
        nombre: 'Estado',
        direccion: 'left',
        propiedad: 'estado',
        titulo: 'realizador',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'Visibilidad',
        direccion: 'right',
        propiedad: 'visible',
        tipo: CASILLA_ESTADO,
        estados: VISIBILIDADMOVIMIENTO
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]